var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlareWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9463 13.6911L12.3037 13.6836C9.67452 13.6836 7.48889 15.7626 7.41998 18.4349C7.41783 18.506 7.47704 18.5652 7.5481 18.5652L17.1907 18.5717C19.8199 18.5727 22.0056 16.4937 22.0745 13.8225C22.0766 13.7514 22.0174 13.6922 21.9463 13.6922V13.6911Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8344 6.37082L12.3037 6.36328C9.67452 6.36328 7.48889 8.44232 7.41998 11.1146C7.41783 11.1857 7.47704 11.2449 7.5481 11.2449L22.0788 11.2513C24.708 11.2524 26.8936 9.17338 26.9625 6.50217C26.9647 6.43111 26.9055 6.37189 26.8344 6.37189V6.37082Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3242 25.8162C11.6497 25.561 12.5173 24.2796 12.262 22.9541C12.0068 21.6287 10.7254 20.7611 9.39994 21.0164C8.07449 21.2716 7.20691 22.553 7.46215 23.8785C7.7174 25.2039 8.9988 26.0715 10.3242 25.8162Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlareWhite);
export default __webpack_public_path__ + "static/media/flare-white.8227120847bc81df9c0f7ba024faed5a.svg";
export { ForwardRef as ReactComponent };